import { Heart, TrendingDown, TrendingUp, Wallet } from "lucide-react";
import { Card } from "@/components/ui/card";

const brl = (v) =>
  (v ?? 0).toLocaleString("pt-BR", {
    style: "currency", currency: "BRL", maximumFractionDigits: 0,
  });

const RATING_STYLE = {
  ótimo:   { color: "text-emerald-400", ring: "ring-emerald-400/30" },
  bom:     { color: "text-cyan-400",    ring: "ring-cyan-400/30" },
  atenção: { color: "text-amber-400",   ring: "ring-amber-400/30" },
  alerta:  { color: "text-red-400",     ring: "ring-red-400/30" },
};

/**
 * FinancialHealthCard — score 0-100 composto + drivers.
 * Renderiza payload de backend build_financial_health.
 */
export default function FinancialHealthCard({ data }) {
  const score = data?.score ?? 0;
  const rating = data?.rating || "—";
  const style = RATING_STYLE[rating] || RATING_STYLE["atenção"];
  const drivers = data?.drivers || [];

  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="text-xs text-foreground-muted mb-3">Saúde financeira</div>

      {/* Score destaque */}
      <div className="flex items-center gap-4 mb-3">
        <div
          className={`flex items-center justify-center w-16 h-16 rounded-full bg-surface-card-hover ring-2 ${style.ring}`}
        >
          <Heart className={`w-7 h-7 ${style.color}`} />
        </div>
        <div className="flex-1">
          <div className="text-2xl font-bold text-foreground leading-none">
            {score}<span className="text-sm text-foreground-muted">/100</span>
          </div>
          <div className={`text-sm capitalize ${style.color}`}>{rating}</div>
        </div>
      </div>

      {/* Métricas-chave */}
      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="flex items-center gap-2 py-2 px-3 rounded-lg bg-surface-card-hover">
          <Wallet className="w-4 h-4 text-emerald-400" />
          <div>
            <div className="text-[10px] text-foreground-muted">Saldo</div>
            <div className="text-xs font-semibold text-foreground">
              {brl(data?.total_balance)}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 py-2 px-3 rounded-lg bg-surface-card-hover">
          <TrendingDown className="w-4 h-4 text-rose-400" />
          <div>
            <div className="text-[10px] text-foreground-muted">Gasto mês</div>
            <div className="text-xs font-semibold text-foreground">
              {brl(data?.month_expenses)}
            </div>
          </div>
        </div>
      </div>

      {/* Drivers */}
      {drivers.length > 0 && (
        <div className="space-y-1">
          <div className="text-[10px] text-foreground-muted uppercase tracking-wider mb-1">
            Bons sinais
          </div>
          {drivers.slice(0, 4).map((d, i) => (
            <div
              key={i}
              className="flex items-center gap-2 py-1.5 px-3 rounded-lg bg-surface-card-hover"
            >
              <TrendingUp className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0" />
              <div className="text-xs text-foreground">{d}</div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
